import { React } from "react";

const GrievanceHeader = () => {
  return (
    <>
      <div className="grievance-header">
        <div className="watcho-navbar">
          <div className="watcho-logo-nav">
            <a href="https://www.vzy.one/" className="watcho-logo-link">
              <img
                src="https://d2ivesio5kogrp.cloudfront.net/static/watcho/images/logo.svg"
                alt="vzy Logo"
                className="watcho-logo"
              />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default GrievanceHeader;
